import React, { useState } from "react";
import {
  Radio,
  FormControlLabel,
  RadioGroup,
  Grid,
  Typography,
} from "@material-ui/core";
import { RemittanceType } from "../types";
import useStyles from "./styles";
import { useReportTerminationContext } from "../ReportTerminationContext";
import { FinalPay } from "generated/graphql";

const RemittanceGridRow = () => {
  const classes = useStyles();
  const { dispatch } = useReportTerminationContext();
  const [remittanceType, setRemittanceType] = useState<RemittanceType>(
    "invoice"
  );

  const handleRadioGroupChange = (
    event: React.ChangeEvent<unknown>,
    value: string
  ) => {
    const remittanceType = value as RemittanceType;
    dispatch({
      type: "updateFinalPayType",
      finalPayType:
        remittanceType === "invoice"
          ? FinalPay.PaperCheckOnly
          : FinalPay.PaperCheckAndDirectDeposit,
    });
    setRemittanceType(remittanceType);
  };

  return (
    <Grid container alignItems="flex-start">
      <Grid item xs={6} className={classes.groupLabel}>
        <Typography>Remittance to DailyPay from partner</Typography>
      </Grid>
      <Grid item xs={6}>
        <RadioGroup
          name={"finalPayDetailsRadioGroup"}
          onChange={handleRadioGroupChange}
          value={remittanceType}
        >
          <FormControlLabel
            value="invoice"
            control={<Radio color="primary" />}
            label="Invoice"
            labelPlacement="end"
          />
          <FormControlLabel
            value="dailyPayAccount"
            control={<Radio color="primary" />}
            label="DailyPay Account"
            labelPlacement="end"
          />
        </RadioGroup>
      </Grid>
    </Grid>
  );
};

export default RemittanceGridRow;
